import {
    Theme,
    WithStyles,
    Typography,
    StandardProps,
    TablePagination
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import React, { ReactNode } from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import Paper from "@material-ui/core/Paper";
import Table, { TableClassKey } from "@material-ui/core/Table";
import { TableProps } from "@material-ui/core/Table";
import { PaginationInfo, extractPaginationDetail } from "js/types";
import {
    PerPageSelectorProps,
    PaginationProps,
    PerPageSelector,
    Pagination
} from "js/react/components";
import { StyleClassKey, StylesType } from "js/react/typescript";

const styles = (theme: Theme) =>
    createStyles({
        paper: {
            color: theme.palette.text.primary,
            flexGrow: 1
        },
        rightContainer: {
            display: "flex"
        },
        leftContainer: {},
        table: {
            fontWeight: "bold",
            borderColor: theme.palette.divider
        },
        tableTopToolbar: {
            display: "flex",
            alignItems: "center",
            margin: theme.spacing(1),
            justifyContent: "space-between"
        },
        perPageContainer: {
            flexGrow: 1
        },
        paginationContainer: {
            color: "grey",
            fontSize: "0.75rem"
        }
    });

export type AppTableClassKey = StyleClassKey<typeof styles> | TableClassKey;

export interface AppTableProps
    extends StandardProps<TableProps, AppTableClassKey> {
    perPageProps?: PerPageSelectorProps;
    paginationInfo?: PaginationInfo;
    rightToolContainer?: ReactNode;
    leftToolContainer?: ReactNode;
    paginationProps?: PaginationProps;
    selectedCount: number;
}

const decorator = withStyles(styles as StylesType<AppTableClassKey>);

function Component({
    rightToolContainer,
    leftToolContainer,
    paginationInfo,
    paginationProps,
    selectedCount,
    perPageProps,
    classes,
    ...rest
}: AppTableProps) {
    const {
        rightContainer,
        leftContainer,
        perPageContainer,
        tableTopToolbar,
        paper,
        table,
        paginationContainer,
        ...restClasses
    } = classes;

    const detail = paginationInfo
        ? extractPaginationDetail(paginationInfo)
        : null;

    return (
        <Paper className={paper} elevation={0}>
            {(leftToolContainer || rightToolContainer) && (
                <div className={tableTopToolbar}>
                    <div className={leftContainer}>{leftToolContainer}</div>
                    <div className={rightContainer}>{rightToolContainer}</div>
                </div>
            )}
            <Table
                {...{ border: 1 }}
                className={table}
                {...rest}
                classes={restClasses}
            ></Table>
            <div className={tableTopToolbar}>
                <div></div>
                {/* <Typography className={perPageContainer}>
                    {detail && paginationInfo.total > 0
                        ? `Showing ${detail.startingItem} to ${detail.endingItem} of ${detail.total} entries`
                        : null}
                </Typography> */}
                <div>
                    {paginationInfo && paginationInfo.total > 0 ? (
                        <Pagination
                            info={paginationInfo}
                            {...paginationProps}
                        />
                    ) : null}
                </div>
            </div>
        </Paper>
    );
}

Component.displayName = "AppTable";
Component.defaultProps = {
    paginationProps: {}
} as AppTableProps;

export const AppTable = decorator(Component);
export default AppTable;
